import { render, staticRenderFns } from "./MaintenanceBanner.vue?vue&type=template&id=41b63a30"
import script from "./MaintenanceBanner.vue?vue&type=script&lang=js"
export * from "./MaintenanceBanner.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceBanner.vue?vue&type=style&index=0&id=41b63a30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_pqvrgeoyoc7vllsfv3djl2e3nu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports